export enum EntityType {
  ORDER_REQUEST = 'ORQ',
}
